<template src="./ButtonLoginComponent.html"></template>
<script>
export default {
  name: 'ButtonLoginComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped></style>
